export const ServerResCodeTypeEnum = {
  OK: 200,
  200: "OK"
};

export const DataStateEnum = {
  Loading: "Loading",
  Error: "Error",
  Loaded: "Loaded",
  Empty: "Empty"
};

export const OperationManualUrl =
  "https://bn-lis-prod.tos-cn-beijing.volces.com/bn-lis-prod/common/%E8%B4%9D%E7%BA%B3LIMS%E7%B3%BB%E7%BB%9F-%E5%AE%A2%E6%88%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf";
